import axios from 'axios';
import { URL } from '../constants/url';

export const client = axios.create({
  baseURL: `${URL.RATES}/`,
  headers: {
    'content-type': 'application/json',
  },
});
